import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { Editor, Toolbar } from 'ngx-editor';
import { DeliverySection } from 'src/app/shared/models/data/documentTemplate';
import { createDocumentEditor, DOCUMENT_TEMPLATE_TOOLBAR } from 'src/app/shared/ngx-editor/document-template-editor';

@Component({
  selector: 'app-delivery-section',
  templateUrl: './delivery-section.component.html',
  styleUrls: ['./delivery-section.component.scss']
})
export class DeliverySectionComponent implements OnDestroy {
  @Input() reset!: () => void;
  @Input() delivery: DeliverySection = {
    section: {
      value: ''
    }
  };
  @Output() deliveryChange = new EventEmitter<DeliverySection>();

  editor: Editor = createDocumentEditor();
  toolbar: Toolbar = DOCUMENT_TEMPLATE_TOOLBAR;


  ngOnDestroy(): void {
    this.editor.destroy();
  }

  onEditorChange(newValue: string) {
    this.delivery.section.value = newValue;
    this.delivery.section.isModified = true;
    this.deliveryChange.emit(this.delivery);
  }

}
